import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

// Import Images
import lingBg2 from "../../images/background/line-bg2.png"
import blogGridPic1 from "../../images/blog/grid/pic4.jpg"
import blogGridPic2 from "../../images/blog/grid/pic5.jpg"
import blogGridPic3 from "../../images/blog/grid/pic6.jpg"
import facebook from '../../images/social/facebook.png';
import twitter from '../../images/social/twitter.png';
import instagram from '../../images/social/instagram.png';

// Team Content
const content = [
	{
		thumb: blogGridPic1,
		authorPic: twitter,
		author: "TikTok",
		title: "When will you realize, we're not like the rest",
		date: "August 15th, 2026",
		link: "https://www.tiktok.com/@familyecodental/video/7674002728334478605?is_from_webapp=1&sender_device=pc",
	},
	{
		thumb: blogGridPic2,
		authorPic: facebook,
		author: "Facebook",
		title: "We're Hiring a Dental Hygienist! Join our compassionate and eco-conscious team at Family Eco Dental. Apply now to be part of a modern dental practice that values both patient care and environmental responsibility.",
		date: "August 17th, 2026",
		link: "https://www.facebook.com/share/p/1GeZ9UoKu5/",
	},
	{
		thumb: blogGridPic3,
		authorPic: instagram,
		author: "Instagram",
		title: "Celebrating Our Team's August Birthdays!",
		date: "August 14th, 2026",
		link: "https://www.instagram.com/p/Db_vyBVkYnf/?utm_source=ig_web_button_share_sheet",
	},
	// {
	// 	thumb: blogGridPic4,
	// 	authorPic: testPic4,
	// 	author: "Kalina Mollika",
	// 	title: "Dental Care for Women is very important",
	// 	date: "18 July 2021",
	// },
	// {
	// 	thumb: blogGridPic5,
	// 	authorPic: testPic5,
	// 	author: "Michel",
	// 	title: "Health Will Be A Thing Of The Past And Here's Why",
	// 	date: "17 July 2021",
	// },
]

const NewsItem = ({ item }) => {
  return (
    <div className="slider-item">
      <div className="blog-card">
        <div className="post-media">
          <Link to={item.link}><img src={item.thumb} alt="" /></Link>
        </div>
        <div className="post-info">
          <ul className="post-meta">
            <li className="author"><Link to={item.link}><img src={item.authorPic} alt="" />{item.author}</Link></li>
            <li className="date"><i className="far fa-calendar-alt"></i>{item.date}</li>
          </ul>
          <h5 className="post-title"><Link to={item.link}>{item.title}</Link></h5>
          <Link to={item.link} className="btn btn-outline-primary btn-sm">Read More <i className="btn-icon-bx fas fa-chevron-right"></i></Link>
        </div>
      </div>
    </div>
  );
};


const settings = {
	dots: false,
	infinite: true,
	speed: 1000,
	slidesToShow: 3,
	slidesToScroll: 1,
	responsive: [
		{
			breakpoint: 1191,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
			}
		},
	],
};

class LatestNewsSection extends Component {
	render() {
		return (
			<>
				<section className="section-area section-sp1 blog-area" style={{ backgroundImage: "url(" + lingBg2 + ")", backgroundPosition: "center", backgroundSize: "cover", }}>
					<div className="container">
						<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Latest Posts</h6>
							<h2 className="title">Our Latest Posts</h2>
						</div>

						<Slider {...settings} className="tt-slider blog-slide slider-sp0 slick-arrow-none">
							{content.map((item) => (
								<NewsItem key={item.title} item={item} />
							))}
						</Slider>

					</div>

					{/* <img className="pt-img1 animate1" src={animate1} alt=""/>
					<img className="pt-img2 animate2" src={animate2} alt=""/>
					<img className="pt-img3 animate-rotate" src={animateRotate} alt=""/>
					<img className="pt-img4 animate-wave" src={animateWave} alt=""/> */}
				</section>

			</>
		);
	}
}

export default LatestNewsSection;